module.exports = __webpack_public_path__ + "assets/img/block-hover-f5569a8c.png";